export default "https://assets.pclncdn.com/web/next-landing/01bc7bc/_next/static/images/cobrand-cruises-only-promo-22829eb309ed1658cbaafb48728200cc.jpg";